import { Grid } from "@mui/material";
import { useState } from "react";
import { createEntityStore } from "../../common/entityStore";
import { propFileField } from "../../common/entityStoreForm";
import { propRequired, propValueValidator } from "../../common/entityStoreValidators";
import { Run } from "./Run";
export function EPreferencesRunPage() {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({    
        data: {},
        id: null,
        propValidators: [
            propRequired("file"),
            propValueValidator("isFileImported", p => p && "File is already imported."),
        ]
    }));
    const [isRunning, setIsRunning] = useState(false);
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
        </>;
    }
    return <>
        <Run name="Email preferences" hub="ePreferenceRun" onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
            useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />
    </>;
}

interface RunParams {
    file?: File;
    isFileImported?: boolean;
}
